// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import React, { useRef } from 'react';
import { SymbolLookupViewItemHelper } from '@shared/utils/Instruments/SymbolLookupViewItemHelper';
export const InstrumentTypeLogo = ({ instrument, instrumentType, onClick, tooltip, isNeedHoverEffect = false, disabled = false }) => {
    let shortName = '';
    let color = '';
    if (!isNullOrUndefined(instrument)) {
        shortName = SymbolLookupViewItemHelper.getInstrumentTypeShortForInstrument(instrument);
        color = SymbolLookupViewItemHelper.getInstrumentTypeColorForInstrument(instrument);
    }
    else if (!isNullOrUndefined(instrumentType)) {
        shortName = SymbolLookupViewItemHelper.getInstrumentTypeShort(instrumentType);
        color = SymbolLookupViewItemHelper.getInstrumentTypeColor(instrumentType);
    }
    if (!isValidString(shortName)) {
        return null;
    }
    const elementRef = useRef(null);
    const handlePointerEnter = () => {
        if (isValidString(tooltip)) {
            showTooltip(elementRef.current, tooltip);
        }
    };
    const handlePointerLeave = () => {
        hideTooltip();
    };
    const onLogoClick = () => {
        if (!isNullOrUndefined(onClick)) {
            onClick();
        }
    };
    return (React.createElement("div", { ref: elementRef, className: `instrument-type-logo${isNeedHoverEffect ? ' can-hovered' : ''}`, style: { backgroundColor: color }, "aria-disabled": disabled, onClick: onLogoClick, onPointerEnter: handlePointerEnter, onPointerLeave: handlePointerLeave },
        React.createElement("span", null, shortName)));
};
